export const auth = {
  mutations: {
    UNSET_TOKEN_DATA: 'UNSET_TOKEN_DATA',
    SET_TOKEN_DATA: 'SET_TOKEN_DATA',
    SET_TEMP_TOKEN: 'SET_TEMP_TOKEN',
  },
};
export const brand = {
  mutations: {
    UPDATE_TITLE: 'UPDATE_TITLE',
    UPDATE_COPYRIGHT_TEXT: 'UPDATE_COPYRIGHT_TEXT',
    UPDATE_THEME: 'UPDATE_THEME',
    UPDATE_LOGO: 'UPDATE_LOGO',
    UPDATE_FEEDBACK_URL: 'UPDATE_FEEDBACK_URL',
    CLEAR_LOGO_FILE: 'CLEAR_LOGO_FILE',
    SET_BRAND: 'SET_BRAND',
    TOGGLE_PREVIEW: 'TOGGLE_PREVIEW',
  },
};

export const loader = {
  mutations: {
    SET_LOADER_VISIBILITY: 'SET_LOADER_VISIBILITY',
    SET_LOADER_MESSAGE: 'SET_LOADER_MESSAGE',
  },
};

export const errorPage = {
  mutations: {
    SET_ERROR_PAGE_VISIBILITY: 'SET_ERROR_PAGE_VISIBILITY',
    SET_ERROR_PAGE_CONTENT: 'SET_ERROR_PAGE_CONTENT',
  },
};

export const locale = {
  mutations: {
    SET_LOCALE: 'SET_LOCALE',
  },
};
